var render = function render(){var _vm=this,_c=_vm._self._c;return _c('template-default',[_c('article',{staticClass:"template template--navbar-fixed"},[_c('content-header',{staticClass:"content-header--bg",attrs:{"type":"h1"}},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('section',{staticClass:"content content--max-width content--margin container-fluid",domProps:{"innerHTML":_vm._s(_vm.sanitize(_vm.body))}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }